import {
  Avatar,
  AvatarFallback,
  Badge,
  Heading,
  Icon,
  TextField,
} from "@elaniintc/goes-design-system";
// import { VersionDropdown } from "./VersionDropdown";
import { SectionList } from "./SectionList";
import { useEntity } from "../context";
import { SectionListView } from "./SectionListView";
import { RolesList } from "./RolesList";
import { EntityStatusBadge } from "../../components/EntityBadge";

export const EditorSection = () => {
  const { entity, entityTitle, entityType, setEntityTitle } = useEntity();
  const hasPreviousVersion =
    !!entity?.active_version &&
    entity.active_version.version !== entity.version;
  return (
    <div className="flex flex-col flex-1 md:flex-row gap-3 p-8">
      <div className="w-full md:w-1/2">
        <div className="p-4 flex flex-col gap-4">
          <Avatar>
            <AvatarFallback
              color={entityType === "company" ? "info" : "neutral"}
            >
              <Icon
                type="fas"
                size="sm"
                name={entityType === "company" ? "file-shield" : "folder"}
                className={
                  entityType === "company"
                    ? "text-info-quiet"
                    : "text-body-quiet"
                }
              />
            </AvatarFallback>
          </Avatar>
          <div className="flex items-center gap-1">
            <Heading variant="h5" color="loud" className="truncate">
              {entityTitle || ""}
            </Heading>
          </div>
          <hr className="border-neutral-quiet" />
          <SectionListView />
        </div>
      </div>
      <div className="w-full grow md:w-1/2 bg-neutral-object border border-neutral-quiet rounded-lg">
        <div className="border-b border-neutral-quiet">
          <div className="flex justify-between items-center gap-2 px-4 py-2">
            <p className="leading-3xl text-body-loud font-semibold truncate">
              {entityTitle || ""}
            </p>
            <div className="flex items-center gap-2">
              <p className="text-body-quiet text-size-body-sm truncate">
                Guardar creará una nueva versión
              </p>
              {/* <VersionDropdown
                version={entityVersion}
                versions={entityVersions}
                onVersionSelect={(version) => {
                  navigate(`/expedientes/entidad/${version.id}`);
                }}
              /> */}
              {entity && (
                <div className="flex items-center" data-testid="version-badges">
                  <EntityStatusBadge
                    entity={entity}
                    className={hasPreviousVersion ? "rounded-r-none" : ""}
                  >
                    {`v${entity.version} ${entity.status_label ?? entity.status}`}
                  </EntityStatusBadge>
                  {hasPreviousVersion && (
                    <Badge
                      size="sm"
                      variant="success"
                      className="rounded-l-none -ml-px"
                    >
                      Activa v{entity.active_version?.version}
                    </Badge>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="px-2">
          <div className="px-2 py-3">
            <TextField
              label="Título de la entidad"
              required
              placeholder="Escribe el nombre de la entidad"
              value={entityTitle}
              onChange={(e) => setEntityTitle(e.target.value)}
            />
            <RolesList
              label="Roles"
              required
              aria-required
              placeholder="Añade un nuevo item"
            />
            <SectionList />
          </div>
        </div>
      </div>
    </div>
  );
};
